<template>
  <div class="language-switcher">
    <select 
      v-model="selectedLocale" 
      @change="changeLocale"
      @click="toggleSize"
      :class="{ 'expanded': isExpanded }"
    >
      <option v-for="locale in availableLocales" :key="locale.code" :value="locale.code">
        {{ locale.name }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();
const selectedLocale = ref(i18n.locale.value);
const isExpanded = ref(false);

const availableLocales = [
  { code: 'ko', name: '한국어' },
  { code: 'en', name: 'English' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'mn', name: 'Монгол' }
];

const changeLocale = () => {
  i18n.locale.value = selectedLocale.value;
  localStorage.setItem('userLocale', selectedLocale.value);
};

const toggleSize = (e) => {
  e?.stopPropagation();
  isExpanded.value = !isExpanded.value;
};

onMounted(() => {
  // 브라우저에 저장된 언어 설정이 있으면 로드
  const savedLocale = localStorage.getItem('userLocale');
  if (savedLocale) {
    selectedLocale.value = savedLocale;
    i18n.locale.value = savedLocale;
  }

  window.addEventListener('click', () => {
    isExpanded.value = false;
  });
});
</script>

<style scoped>
.language-switcher {
  position: relative;
  margin-right: 15px;
}

select {
  background-color: transparent;
  color: var(--color-white);
  padding: 2px;
  border: none;
  font-size: var(--fs-13);
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 1.5rem;
  width: 90px;
  transition: all 0.3s ease;
}

/* 모바일 환경에서는 transition 제거 */
@media (max-width: 768px) {
  select {
    width: 100px;
    transition: none;
  }
}

select.expanded {
  width: 100px;
}

select:hover {
  color: var(--color-one);
}

.language-switcher::after {
  content: "\F282";
  font-family: "bootstrap-icons";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-one);
  pointer-events: none;
}

select option {
  background-color: #1a1a1a;
  color: var(--color-white);
}
</style> 